import { render, staticRenderFns } from "./RedeemVerificationCode.vue?vue&type=template&id=2296597a&scoped=true&lang=pug&"
import script from "./RedeemVerificationCode.vue?vue&type=script&lang=js&"
export * from "./RedeemVerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./RedeemVerificationCode.vue?vue&type=style&index=0&id=2296597a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296597a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VOtpInput})
